import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { getConnection, getErrorMessage, hideSpinner, ignoreSpecialCharacters, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { map, startWith } from 'rxjs/operators';
import { OpcionMenuSicfModel } from '../../models/opcion-menu.model';
import { OpcionesMenuService } from '../../services/opciones.service';
import { ActivatedRoute } from '@angular/router';
import { arrayNotEmpty, isEmpty } from 'class-validator';
import { ModulosService } from '../../services/modulos.service';
import { CokyTableColumn } from 'src/app/modules/shared/imports/components/table/table.component';

@Component({
  selector: 'app-opciones-menu',
  templateUrl: './opciones-menu.component.html',
  styleUrls: ['./opciones-menu.component.scss']
})
export class OpcionesMenuComponent implements OnInit {

  modules: any[] = []
  options: any[] = []
  parentOptions: any[] = []
  selectedOption: OpcionMenuSicfModel | undefined
  optionColumns: CokyTableColumn[] = [
    { name: "codigo", title: "codigo" },
    { name: "opcion", title: "opcion" },
    { name: "modulo", title: "modulo" },
    { name: "estado", title: "estado" },
  ]
  form: FormGroup
  icons: string[] = []


  constructor(
    private opcionesService: OpcionesMenuService,
    private helpers: HelpersService,
    private formBuilder: FormBuilder,
    private modulosService: ModulosService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.form = this.formBuilder.group({
      codigo_modulo: ["", [Validators.required, Validators.maxLength(4)]],
      codigo_padre: ["",],
      estado: ["", [Validators.required, Validators.maxLength(1)]],
      descripcion_opcion: ["", [Validators.required]],
      icono: ["", [Validators.required]],
      funcionalidad_general: [""],
      ruta: [""],
    })
    this.resetForm()
  }

  async ngOnInit() {
    const data = this.activatedRoute.snapshot.data
    if (data.title) {
      this.helpers.setTitle(data.title);
    }
    await this.getAllOptions()
    await this.getIcons()
    await this.getAllModules()
  }

  async getIcons() {
    try {
      this.icons = await this.helpers.getIcons()
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
    }
  }
  setValue(controlName: string, value: string) {
    this.form.get(controlName)?.setValue(value)
    return value
  }
  resetForm(selectedOption: OpcionMenuSicfModel | undefined = undefined) {
    if (selectedOption == undefined) {
      this.selectedOption = undefined
      this.form.reset()
    } else {
      this.form.get("c_emp")?.setValue(selectedOption?.c_emp)
      this.form.get("codigo_modulo")?.setValue(selectedOption?.codigo_modulo)
      this.form.get("codigo_padre")?.setValue(selectedOption?.codigo_padre)
      this.form.get("estado")?.setValue(selectedOption?.estado)
      this.form.get("descripcion_opcion")?.setValue(selectedOption?.descripcion_opcion)
      this.form.get("icono")?.setValue(selectedOption?.icono)
      this.form.get("funcionalidad_general")?.setValue(selectedOption?.funcionalidad_general)
      this.form.get("ruta")?.setValue(selectedOption?.ruta)
    }
    this.setParentOptions()
  }
  async getAllModules() {
    showSpinner()
    try {
      const result = await this.modulosService.findAll()
      if (result.success) {
        this.modules = result.data
      } else {
        this.helpers.notifications.errorMessage(result.message)
      }
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
    }
    hideSpinner()
  }
  async getAllOptions() {
    this.options = []
    showSpinner()
    try {
      const result = await this.opcionesService.findAll()
      if (result.success) {
        this.options = result.data
      } else {
        this.helpers.notifications.errorMessage(result.message)
      }
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
    }
    hideSpinner()
  }

  async getOneModule(codigo_opcion: string) {
    try {
      const result = await this.opcionesService.findOne(codigo_opcion)
      if (result.success) {
        return result.data
      } else {
        this.helpers.notifications.errorMessage(result.message)
        return null
      }
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
      return null
    }
  }

  async showMenuOptions(selected: any[]) {
    showSpinner()
    if (arrayNotEmpty(selected) && selected[0].codigo) {
      this.selectedOption = undefined
      this.selectedOption = await this.getOneModule(selected[0].codigo)
      if (this.selectedOption?.codigo_modulo) {
        this.resetForm(this.selectedOption)
      }
    }
    hideSpinner()
  }

  async create() {
    showSpinner()
    if (this.form.valid) {
      try {
        const result = await this.opcionesService.create(this.form.value)
        if (result.success) {
          await this.getAllOptions()
          this.helpers.notifications.successMessage(result.message)
        } else {
          this.helpers.notifications.errorMessage(result.message)
        }
        hideSpinner()
      } catch (error) {
        hideSpinner()
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    } else {
      hideSpinner()
      this.helpers.notifications.errorMessage("Debe completar algunos campos o son demasiado largos")
    }
  }

  async modify() {
    showSpinner()
    if (this.form.valid && this.selectedOption && this.selectedOption.codigo_opcion) {
      try {
        const result = await this.opcionesService.update(this.form.value, {
          c_emp: getConnection(),
          codigo_opcion: this.selectedOption?.codigo_opcion
        })
        if (result.success) {
          await this.getAllOptions()
          await this.showMenuOptions([{ codigo: result.data.current[0].codigo_opcion }])
          this.helpers.notifications.successMessage(result.message)
        } else {
          this.helpers.notifications.errorMessage(result.message)
        }
        hideSpinner()
      } catch (error) {
        hideSpinner()
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    } else {
      hideSpinner()
      this.helpers.notifications.errorMessage("Debe completar algunos campos o son demasiado largos")
    }
  }

  print(value) {
    return JSON.stringify(value)
  }

  ignoreSpecialCharactersVoid(controlName: string, value: string) {
    let hola = ignoreSpecialCharacters(value)
    this.form.get(controlName)?.setValue(hola)
    return hola
  }

  exclude(array: any[], toRemove: any[], key: string) {
    const result = array.filter(value => {
      const find = toRemove.find(val => value[key] == val[key])
      return find == undefined;
    });
    return result
  }

  include(array: any[], toInclude: any[], key: string) {
    const result = array.filter(value => {
      const find = toInclude.find(val => value[key] !== val[key])
      return find == undefined;
    });
    return result
  }

  setParentOptions() {
    //Esperamos un momento para que se cargue el cambio en form.get
    setTimeout(() => {
      const module = this.modules.find(m => m.codigo == this.form.get("codigo_modulo")?.value)
      if (module) {
        const parentOptions = this.options.filter(o => {
          return o.modulo === module.descripcion
        })
        this.parentOptions = parentOptions ? parentOptions : []
      }
    }, 300);
  }
}

